import {ChangeDetectorRef, Component, inject} from '@angular/core';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {SupportApiService} from '../../services/support-api.service';
import {map, switchMap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {CategoryInterface} from '../../interfaces/http.interface';
import {ProgressSpinnerComponent} from '../progress-spinner/progress-spinner.component';
import {SessionStorageService} from 'ngx-webstorage';
import {NgArrayPipesModule} from 'ngx-pipes';

@Component({
  selector: 'app-support-departments',
  imports: [
    TopBarComponent,
    AsyncPipe,
    MatIcon,
    ProgressSpinnerComponent,
    NgArrayPipesModule
  ],
  templateUrl: './support-departments.component.html',
  styleUrl: './support-departments.component.scss'
})
export class SupportDepartmentsComponent {
  public display_name = '';
  public request_id = '';
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private supportApiService: SupportApiService = inject(SupportApiService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  public orderId = this.sessionStorageService.retrieve('order_id');
  public categories$ = this.route.queryParamMap.pipe(
    switchMap(params => {
      this.display_name = String(params.get('display_name'));
      this.request_id = params.get('request_id') ? String(params.get('request_id')) : '';
      this.cdr.detectChanges();
      return this.supportApiService.getCategories(String(params.get('department_uuid')));
    }),
    map(data => data?.data),
    takeUntilDestroyed()
  );

  openStandardSolution(item: CategoryInterface) {
    this.router.navigate(['/standard-solution'], {
      queryParams: {
        display_name: item.display_name,
        category_uuid: item.uuid,
        department_uuid: this.route.snapshot.queryParamMap.get('department_uuid'),
        request_id: this.request_id
      }
    });

  }
}
